import Vue from 'vue'
import VuePageTransition from 'vue-page-transition'
 
Vue.use(VuePageTransition)